import React from 'react';
import Intro from './intro';
import Menu from './menu';
import Contact from './contact';
import ImageCarousel from './ImageCarousel';

const ArtPortfolio = () => {
    return (
            <>
                <Intro />
                <Menu />
                <div id="portfolio-wrapper">
                    <div className="container">
                        <div id="artist-portfolio" className="col-12">
                            <h1 className="section-title">Artist Portfolio</h1>
                            <div className="row">
                                <h2 className="section-title col-12 col-sm-6">Founder & Maker - Tinker's Hearth</h2>
                                <div className="col-12 col-sm-6 justify-content-center justify-content-sm-end d-flex th-links">
                                    <a href="https://craftsregister.gov.mt/craftsperson/1JQLYW/"><img src="/img/craftsregister.png"/></a>
                                    <a href="https://www.facebook.com/tinkers.hearth"><img src="/img/fb.svg"/></a>
                                    <a href="https://www.instagram.com/tinkershearth/"><img src="/img/insta.svg"/></a>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-sm-4 d-flex align-self-center align-items-center th-logo"><img src="/img/TH/TH_Logo.png"></img></div>
                                <div className="col-12 col-sm-8">
                                    <p>
                                        Created and continue to nurture Tinker's Hearth, a personal artisan brand rooted in mindful 
                                        “tinkering” and the idea of the hearth as a warm, glowing space for creativity, curiosity,
                                        and making mistakes without fear. It's a place where ceramics, stained glass, leatherwork, 
                                        and other hands-on crafts meet playful experimentation and lifelong learning.
                                    </p>
                                    <p>
                                        I'm especially excited about growing a community of fellow makers—people who want to share skills, 
                                        insights, half-finished experiments, and the occasional failure. Tinker's Hearth is meant to feel 
                                        less like a polished storefront and more like a shared workshop table: a bit messy, very alive, 
                                        and always evolving.
                                    </p>
                                    <p>
                                        I'm proud to be shaping this into a long-term creative practice, with plans to bring it 
                                        into the world through future festival stalls and collaborations.
                                    </p>
                                </div>
                            </div>
                            <ImageCarousel imgFolder="TH" imgCount={10}/>
                            <div className="row">
                                <h2 className="section-title col-sm-9 col-12">Musical Theatre & Voice Acting</h2>
                                <a target="_blank" className="col-sm-3 col-10 m-auto btn btn-primary align-self-center" href="/docs/Drama_CV.pdf">Download Drama CV</a>                        
                                <div className="col-12">
                                    <p>
                                        Michelle Falzon is a Malta-based performer and creative professional with a strong background in musical theatre, live performance, and vocal work.
                                        Alongside her career in game development and studies in Artificial Intelligence at the University of Malta, she has built extensive experience 
                                        on stage as a vocalist, actress, dancer, and soloist in productions with Arthaus (formerly DLS Productions), UoM Studentsfest, and community performance groups. 
                                    </p>
                                    <p>
                                        Her credits include featured roles in Destinaion Musicals: One more time!, Belliegħa, A War to End All Wars?, and Ghosts of Christmas past, 
                                        as well as ensemble and chorus performances in productions such as Sai Mulan, Beautie and the Beast, and Carmen: The Rock Musical. 
                                    </p>
                                    <p>
                                        She has also contributed backstage and voice-over work, including narration for Conflict of Nations WW3 tutorials.
                                    </p>
                                    <p>
                                        Michelle developed her craft through vocal training and specialised workshops in acting, musical theatre,
                                        dance, and performance techniques, having trained with both local and international industry professionals. Warm, versatile,
                                        and collaborative, she brings enthusiasm, stage presence, and a strong creative foundation to every production she joins.
                                    </p>
                                    <div className="col-12 d-flex justify-content-center links">
                                        <a target="_blank" className="float-right btn btn-primary align-self-center" href="https://www.youtube.com/watch?v=k_dEu8NRF1s">Voice Overs</a>
                                        <a target="_blank" className="float-right btn btn-primary align-self-center" href="https://www.youtube.com/watch?v=sHHLwF6JLgI&list=PLVdY3k3OwxOb9wwRPDFsrIghrH-snvOX2">Song Covers</a>
                                    </div>
                                    <ImageCarousel imgFolder="MT" imgCount={8}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <Contact />
        </>
    );
};

export default ArtPortfolio;
